import { RootState } from "../index";

export const getCrestSheet = (state: RootState) => state.ui.sheets.crest;
